import { Component, Inject, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DTypeForm } from '@grupo-constant/next-dtype/form';
import { TranslocoService } from '@ngneat/transloco';
import { UserNodePrivilegesForDisplay } from '../../modules/admin/ou/ou.types';
import { DTypeService } from '../../core/dtype/dtype.service';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';
import { UserProfilePayloadAction } from '../../modules/admin/projects/projects.types';

@Component({
    selector: 'app-user-privilege-dialog',
    templateUrl: './user-privilege-dialog.component.html',
    styles: [
        /* language=SCSS */
        `
            .user-privilege-dialog-panel {

                .mat-mdc-dialog-container {

                    .mat-mdc-dialog-surface {
                        padding: 0 !important;
                    }
                }
            }
        `
    ],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserPrivilegeDialogComponent implements OnInit {

    dTypeForm: DTypeForm;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            privilege: UserNodePrivilegesForDisplay;
            readonly: boolean;
        },
        public dialogRef: MatDialogRef<UserPrivilegeDialogComponent>,
        private dTypeService: DTypeService,
        private fuseConfirmationService: FuseConfirmationService,
        private translocoService: TranslocoService
    ) { }

    async ngOnInit() {
        this.dTypeForm = await this.dTypeService.getDtypeFormByUri({
            uri: this.data.privilege.userDatatypeUri,
            bindableOptions: false
        }, this.data.privilege, { readonly: this.data.readonly });
    }

    async closeDialog() {
        this.dialogRef.close();
    }

    reset() {
        const dialogRef = this.openConfirmDialog(this.translocoService.translate('resetPermissionConfirm'));
        dialogRef.afterClosed().subscribe(confirm => {
            if (confirm === 'confirmed') {
                this.dialogRef.close({ action: UserProfilePayloadAction.RESET });
            }
        });
    }

    accept() {
        const dialogRef = this.openConfirmDialog(this.translocoService.translate('savePermissionConfirm'));
        dialogRef.afterClosed().subscribe(confirm => {
            if (confirm === 'confirmed') {
                this.dialogRef.close({ action: UserProfilePayloadAction.FLUSH, payload: this.dTypeForm.control.getRawValue() });
            }
        });
    }

    private openConfirmDialog(message: string) {
        return this.fuseConfirmationService.open({
            title: this.translocoService.translate('warning'),
            message: message,
            actions: {
                confirm: {
                    label: this.translocoService.translate('confirm')
                },
                cancel: {
                    label: this.translocoService.translate('cancel')
                }
            }
        });
    }
}
